// Handles navigation for variant selectors (metal, gemstone, size)
// Uses event delegation to survive DOM morphing from variant-picker.js
document.addEventListener('DOMContentLoaded', function () {
  /**
   * @param {string} selectorGroup
   * @param {string} optionTrack
   * @param {string} prevBtn
   * @param {string} nextBtn
   */
  function setupNav(selectorGroup, optionTrack, prevBtn, nextBtn) {
    /** @type {NodeListOf<HTMLElement>} */
    const groups = document.querySelectorAll(selectorGroup);
    groups.forEach(group => {
      /** @type {HTMLElement|null} */
      const track = group.querySelector(optionTrack);
      /** @type {HTMLButtonElement|null} */
      const prev = group.querySelector(prevBtn);
      /** @type {HTMLButtonElement|null} */
      const next = group.querySelector(nextBtn);
      if (!track || !prev || !next) return;
      if (track.dataset.navBound === 'true') {
        const overflow = track.scrollWidth > track.clientWidth + 1;
        prev.disabled = !overflow || track.scrollLeft <= 0;
        next.disabled = !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        return;
      }

      track.dataset.navBound = 'true';

      function getScrollAmount() {
        return Math.max(120, Math.round(track.clientWidth * 0.75));
      }

      function updateArrows() {
        if (!track || !prev || !next) return;
        const overflow = track.scrollWidth > track.clientWidth + 1;
        prev.disabled = !overflow || track.scrollLeft <= 0;
        next.disabled = !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      }

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);

      updateArrows();
    });
  }
  
  // Set up initial navigation
  setupNav('.amolee-gemstone-selector', '.amolee-gemstone-selector__track', '.amolee-gemstone-selector__nav--prev', '.amolee-gemstone-selector__nav--next');
  setupNav('.amolee-metal-selector', '.amolee-metal-selector__track', '.amolee-metal-selector__nav--prev', '.amolee-metal-selector__nav--next');
  setupNav('.amolee-size-selector', '.amolee-size-selector__track', '.amolee-size-selector__nav--prev', '.amolee-size-selector__nav--next');
  
  // Use event delegation for option clicks to survive DOM morphing
  // This listens on document level and filters for our selector options
  document.addEventListener('click', function(e) {
    const target = /** @type {HTMLElement|null} */(e.target instanceof HTMLElement ? e.target : null);
    if (!target) return;
    const option = target.closest('.amolee-metal-selector__option, .amolee-gemstone-selector__option, .amolee-size-selector__option');
    if (!option) return;

    // Find the parent selector group and track
    const gemstoneSelector = option.closest('.amolee-gemstone-selector');
    const metalSelector = option.closest('.amolee-metal-selector');
    const sizeSelector = option.closest('.amolee-size-selector');

    let track = null;
    if (gemstoneSelector) {
      track = gemstoneSelector.querySelector('.amolee-gemstone-selector__track');
    } else if (metalSelector) {
      track = metalSelector.querySelector('.amolee-metal-selector__track');
    } else if (sizeSelector) {
      track = sizeSelector.querySelector('.amolee-size-selector__track');
    }
    if (!track) return;

    // Use requestAnimationFrame to ensure the option is fully rendered
    requestAnimationFrame(() => {
      const optionEl = /** @type {HTMLElement} */(option);
      const optionRect = optionEl.getBoundingClientRect();
      const trackRect = track.getBoundingClientRect();
      // Check if option is fully visible within the track
      const isFullyVisible = optionRect.left >= trackRect.left && optionRect.right <= trackRect.right;
      // If option is not fully visible, scroll to center it
      if (!isFullyVisible) {
        // Calculate the scroll position to center the option in the track
        const optionCenter = optionEl.offsetLeft + (optionEl.clientWidth / 2);
        const trackCenter = track.clientWidth / 2;
        const scrollLeft = optionCenter - trackCenter;
        track.scrollTo({ left: Math.max(0, scrollLeft), behavior: 'smooth' });
      }
    });
  }, true); // Use capture phase to catch the event early
  
  // Re-initialize navigation when variant picker morphs the DOM
  // Listen for the custom event that variant-picker dispatches
  document.addEventListener('variant:update', function() {
    // Small delay to ensure DOM is fully updated
    setTimeout(() => {
      setupNav('.amolee-gemstone-selector', '.amolee-gemstone-selector__track', '.amolee-gemstone-selector__nav--prev', '.amolee-gemstone-selector__nav--next');
      setupNav('.amolee-metal-selector', '.amolee-metal-selector__track', '.amolee-metal-selector__nav--prev', '.amolee-metal-selector__nav--next');
      setupNav('.amolee-size-selector', '.amolee-size-selector__track', '.amolee-size-selector__nav--prev', '.amolee-size-selector__nav--next');
    }, 100);
  });
  
  // Also watch for DOM mutations as a fallback
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            const el = /** @type {HTMLElement} */(node);
            if (el.classList && (
              el.classList.contains('amolee-gemstone-selector') ||
              el.classList.contains('amolee-metal-selector') ||
              el.classList.contains('amolee-size-selector') ||
              el.querySelector('.amolee-gemstone-selector, .amolee-metal-selector, .amolee-size-selector')
            )) {
              setTimeout(() => {
                setupNav('.amolee-gemstone-selector', '.amolee-gemstone-selector__track', '.amolee-gemstone-selector__nav--prev', '.amolee-gemstone-selector__nav--next');
                setupNav('.amolee-metal-selector', '.amolee-metal-selector__track', '.amolee-metal-selector__nav--prev', '.amolee-metal-selector__nav--next');
                setupNav('.amolee-size-selector', '.amolee-size-selector__track', '.amolee-size-selector__nav--prev', '.amolee-size-selector__nav--next');
              }, 50);
            }
          }
        });
      }
    });
  });
  
  // Observe the product info wrapper for changes
  const productInfoWrapper = document.querySelector('.amolee-product-info-wrapper');
  if (productInfoWrapper) {
    observer.observe(productInfoWrapper, {
      childList: true,
      subtree: true
    });
  }
});